/** @format */

import PropTypes from 'prop-types';
import { Box, Button, Dialog, DialogActions, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// import parse from "html-react-parser"
// import {format} from "@flasd/whatsapp-formatting"
import BootstrapDialogTitle from './BootstrapDialogTitle';
import WAPreviewBody from './WAPreviewBody';
import TemplateSample from '../pages/template/TemplateSample';
import React from 'react';

WAPreviewBody.propTypes = {
  content: PropTypes.string,
  footer: PropTypes.string,
  headerFormat: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    // width: 400,
    minHeight: 300,
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    maxWidth: '800px',
  },
}));

export default function WAPreviewModal({
  content,
  open,
  setOpen,
  body,
  setBody,
  headerContent,
  footer,
  header,
  setHeader,
  headerFormat,
  buttonType,
  buttonQuickReply,
  buttonPhoneNumberURL,
}) {
  const [headerImage, setHeaderImage] = React.useState('');
  // console.log(content);
  return (
    <BootstrapDialog open={open} onClose={() => setOpen(false)}>
      <BootstrapDialogTitle onClose={() => setOpen(false)}>
        Preview
      </BootstrapDialogTitle>

      <Box p="10px" display="flex">
        <Box maxWidth="400px" maxHeight="400px" mx="20px" overflow="auto">
          <Typography fontSize="13px" color="#656566">
            To help WhatsApp understand what kind of message you want to send,
            please provide specific content examples for your template. You can
            add a sample file for one or all languages you are submitting.
          </Typography>
          <Box>
            <TemplateSample
              body={body}
              setBody={setBody}
              setHeader={setHeader}
              header={headerContent}
              setHeaderImage={setHeaderImage}
              hheaderImage={headerImage}
            />
          </Box>
        </Box>
        <Box
          sx={{
            px: 3,
            height: '400px',
            width: '300px',
            background: 'url(/static/wabg.jpg) repeat',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
            }}
          >
            <WAPreviewBody
              content={content}
              open={open}
              footer={footer}
              header={header}
              headerFormat={headerFormat}
              headerImage={headerImage}
              buttonType={buttonType}
              buttonQuickReply={buttonQuickReply}
              buttonPhoneNumberURL={buttonPhoneNumberURL}
            />
          </Box>
        </Box>
      </Box>

      <DialogActions>
        <Button autoFocus onClick={() => setOpen((prev) => !prev)}>
          Close
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
